/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPodcastGoogle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 18.75c.759 0 1.375.615 1.375 1.375v1.5a1.375 1.375 0 1 1-2.75 0v-1.5c0-.76.616-1.375 1.375-1.375zm-4.875-4.375c.759 0 1.375.615 1.375 1.375v1.5a1.375 1.375 0 1 1-2.75 0v-1.5c0-.76.616-1.375 1.375-1.375zM16.875 11c.759 0 1.375.616 1.375 1.375v4.875a1.375 1.375 0 1 1-2.75 0v-4.875c0-.759.616-1.375 1.375-1.375zM12 6.625c.759 0 1.375.616 1.375 1.375v8a1.375 1.375 0 1 1-2.75 0V8c0-.759.616-1.375 1.375-1.375zm-9.625 3.25c.759 0 1.375.616 1.375 1.375v1.5a1.375 1.375 0 1 1-2.75 0v-1.5c0-.759.616-1.375 1.375-1.375zm19.25 0c.759 0 1.375.616 1.375 1.375v1.5a1.375 1.375 0 1 1-2.75 0v-1.5c0-.759.616-1.375 1.375-1.375zm-14.5-4.5c.759 0 1.375.616 1.375 1.375v4.906a1.373 1.373 0 0 1-2.747 0H5.75V6.75c0-.759.616-1.375 1.375-1.375zm9.75 0c.759 0 1.375.616 1.375 1.375v1.5a1.376 1.376 0 0 1-2.75 0v-1.5c0-.759.616-1.375 1.375-1.375zM12 1c.759 0 1.375.616 1.375 1.375v1.5a1.376 1.376 0 0 1-2.75 0v-1.5C10.625 1.616 11.241 1 12 1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPodcastGoogle as PodcastGoogle };
